module.exports = __webpack_public_path__ + "static/media/kiss-and-makeup.bc508a4d.PNG";